export enum TcValidatorType {
  Required,
  Min,
  Max,
  IsEmail,
  IsNumber,
  IsDate,
  IsOneOf,
}
